import { render, staticRenderFns } from "./history-sale.vue?vue&type=template&id=3db80239&"
import script from "./history-sale.vue?vue&type=script&lang=js&"
export * from "./history-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports